import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { isLoading } from '../../../../../redux/slicers/accounts';
import Progress from '../../../../widgets/progress';
import NetworkList from '../../NetworkList';
import { INetwork } from '../../../../../models/Network';
import { IGetAccountResponse } from '../../../../../models/Account';
import { IBundlePlan } from '../../../../../models/BundlePlan';

interface BrandsSectionProps {
    account?: IGetAccountResponse;
    networks?: INetwork[];
    userCanWriteNetwork?: boolean;
    bundlePlans?: IBundlePlan[];
}

export const BrandsSection = ({ account, networks, userCanWriteNetwork, bundlePlans = [] }: BrandsSectionProps) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const canAddNetwork = (): boolean => {
        const bundlePlan = bundlePlans.find(({ id }) => id === account?.bundlePlan);
        const brands = bundlePlan?.brands || 0;
        return !!account?.isAgency && !!account?.active && !!userCanWriteNetwork && !dispatch(isLoading('getAssociatedNetworks')) && (networks || []).length < brands;
    };

    const onAddNetwork = (): void => {
        if (account?.id) {
            history.push(`/accounts/networks/${account.id}/create`);
        }
    };

    const renderAddNetworkButton = (): React.ReactElement => {
        if (canAddNetwork()) {
            return (
                <button className="cq-btn" onClick={onAddNetwork}>
                    ADD BRAND
                </button>
            );
        }
        return <></>;
    };

    if (!account?.isAgency) {
        return <></>;
    }

    if (dispatch(isLoading('getAssociatedNetworks')) || dispatch(isLoading('createNetwork')) || dispatch(isLoading('deleteNetwork')) || dispatch(isLoading('updateNetwork'))) {
        return <Progress />;
    }

    if ((networks || []).length > 0) {
        return (
            <div>
                <div className="account-netwrok-heading">
                    <span className="cq-heading">
                        <b>ACCOUNT</b> BRANDS
                    </span>
                    <span>{renderAddNetworkButton()}</span>
                </div>
                {/* @ts-ignore - NetworkList is a JS component with incompatible types */}
                <NetworkList account={account} networks={networks} />
            </div>
        );
    }

    return <></>;
};
